import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux"; // Remove Provider from here
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { Provider } from "react-redux"; // Import Provider from react-redux
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG, THEME_CONSTANT } from "./configs/AppConfig";
import "./lang";
import { onSwitchTheme, onThemeChange } from "store/slices/themeSlice";
import ThemeReveal from "configs/ThemeReveal";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App({ isThemeChanging, currentTheme }) {
  const dispatch = useDispatch();

  useEffect(() => {
    // alert(isThemeChanging)
    if (isThemeChanging == true) {
      setTimeout(() => {
        const theme = currentTheme === "dark" ? "light" : "dark";
        localStorage.setItem(THEME_CONSTANT, theme);
        dispatch(onSwitchTheme(theme));
        dispatch(onThemeChange(false));
      }, 500); // match animation duration
    }
  }, [isThemeChanging]);

  return (
    <div className="App">
      {isThemeChanging && <ThemeReveal theme={currentTheme} />}
      <BrowserRouter history={history}>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <Layouts />
        </ThemeSwitcherProvider>
      </BrowserRouter>
    </div>
  );
}

// Map state to props
const mapStateToProps = ({ theme }) => {
  const { isThemeChanging, currentTheme } = theme;
  return {
    currentTheme,
    isThemeChanging,
  };
};

// Connect App component to Redux store
const ConnectedApp = connect(mapStateToProps, {})(App);

export default function Root() {
  return (
    <Provider store={store}>
      <ConnectedApp />
    </Provider>
  );
}
